import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ENV, IEnvironment } from 'env/config';

import { DataService } from '../http/dataService';
import { CentralApis } from '../interfaces/internal';
import {
  IEventAssignment,
  EventAssignment,
} from '../models/eventAssignment.model';
import { Repository } from './repository';

import { Service } from '../entity';

@Service({
  api: 'event_assignment',
  model: EventAssignment,
})
@Injectable({ providedIn: 'root' })
export class EventAssignmentService extends Repository<EventAssignment> {
  constructor(@Inject(ENV) env: IEnvironment, dataService: DataService) {
    super({
      client: dataService,
      url: (env.api.backend.central.endpoint as CentralApis).territory,
    });
  }

  save(item: any): Observable<EventAssignment> {
    return super.save(item).pipe(map((event) => new EventAssignment(event)));
  }

  createFromDTO(item: IEventAssignment): EventAssignment {
    return EventAssignment.createFromDTO(item);
  }
}
